import React from "react";
import { useLang } from "../context/LanguageContext";
import { ArrowUpRight } from "lucide-react";

const SVC_IMAGES = [
  "https://images.unsplash.com/photo-1638337935003-e17cf483ca8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1NTZ8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwbW9kZWwlMjBlZGl0b3JpYWwlMjBibGFjayUyMGFuZCUyMHdoaXRlfGVufDB8fHx8MTc3ODI4MjUyNnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1761701391167-863560b27f5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxmaWxtJTIwY2FtZXJhJTIwc3R1ZGlvJTIwZGFya3xlbnwwfHx8fDE3NzgyODI1MjZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1677325188706-160d347e3865?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxjb25jZXJ0JTIwZXZlbnQlMjBwaG90b2dyYXBoeSUyMGRhcmt8ZW58MHx8fHwxNzc4MjgyNTI2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1751062190352-721bfdc6f0d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxibGFjayUyMGFuZCUyMHdoaXRlJTIwZ2VvbWV0cmljJTIwYWJzdHJhY3QlMjBkYXJrfGVufDB8fHx8MTc3ODI4MjUzMHww&ixlib=rb-4.1.0&q=85",
];

export default function Services() {
  const { t } = useLang();
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#050505] py-24 md:py-40 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-5">
            <p className="font-mono-tight text-zinc-500 mb-6">{t.services.label}</p>
            <h2 className="text-5xl md:text-7xl font-display tracking-tighter text-white" data-testid="services-title">
              {t.services.title}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-zinc-400 text-lg leading-relaxed" data-testid="services-sub">
              {t.services.sub}
            </p>
          </div>
        </div>

        <div className="border-t border-white/10">
          {t.services.list.map((s, i) => (
            <div
              key={s.num}
              className="svc-row group flex items-center justify-between py-8 md:py-10"
              data-testid={`service-row-${s.num}`}
            >
              <div className="flex items-baseline gap-6 md:gap-12">
                <span className="font-mono-tight text-zinc-600">{s.num}</span>
                <span className="text-3xl md:text-5xl font-light tracking-tight text-zinc-300 group-hover:text-white transition-colors">
                  {s.name}
                </span>
              </div>
              <div className="flex items-center gap-6">
                <span className="hidden lg:block text-sm text-zinc-500 max-w-md text-right">{s.desc}</span>
                <ArrowUpRight className="svc-arrow text-zinc-400 group-hover:text-white" size={28} />
              </div>
              <img
                src={SVC_IMAGES[i % SVC_IMAGES.length]}
                alt=""
                className="svc-img hidden lg:block"
                aria-hidden="true"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
